export default "__VITE_ASSET__DJ5QDzg5__"